<mat-card *ngIf="showWidget" class="mat-elevation-z0" (click)="doCommand()">
    <mat-card-content 
        fxLayout="column" 
        [matTooltip]="'Tiro'"
        matTooltipPosition="below"
    >
        <div class="downstairsDoor-widget" >
            <mat-icon [svgIcon]="downstairsIcon.code" class="downstairs-icon" [ngClass]="downstairsIcon.colorClass"></mat-icon>
        </div>
    </mat-card-content>
</mat-card>